import type { SVGProps } from 'react';
export const Uppercase = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M5.46 5.5a.7.7 0 0 1 .63.38l3.77 7.71c.16.32 0 .7-.34.85a.7.7 0 0 1-.92-.32l-.85-1.75-.2.03H3.38q-.1 0-.2-.03l-.85 1.75a.7.7 0 0 1-.91.32c-.35-.14-.5-.53-.35-.85l3.77-7.71a.7.7 0 0 1 .63-.38M3.8 11.11h3.33L5.46 7.7zM14.54 5.5a.7.7 0 0 1 .63.38l3.77 7.71c.16.32 0 .7-.35.85a.7.7 0 0 1-.91-.32l-.86-1.75-.19.03h-4.19q-.1 0-.19-.03l-.85 1.75a.7.7 0 0 1-.92.32c-.35-.14-.5-.53-.34-.85l3.77-7.71a.7.7 0 0 1 .63-.38m-1.67 5.61h3.33L14.54 7.7z"
      clipRule="evenodd"
    />
  </svg>
);
